module.exports = __webpack_public_path__ + "static/media/aac.308e5969.svg";